import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";
import { useFeatureFlag } from "@/hooks/use-feature-flag";
import type { DBSignalQueueItem } from "@/lib/db-types";

const QUEUE_SIZE = 5;

/**
 * Signalkortene i køen (RPC next_signals_for_me). RPC-en bruker den faktisk
 * innloggede brukeren (auth.uid), ikke en impersonert, så nøkkelen følger
 * samme bruker. Kortene hentes bare når signal-flagget er på.
 * Realtime på customer_signals og signal_dismissals invaliderer ["signal-queue"].
 */
export function useSignalQueue() {
  const { user } = useAuth();
  const enabled = useFeatureFlag("feature_crm_signaler");
  return useQuery({
    queryKey: ["signal-queue", user?.id ?? null],
    queryFn: async (): Promise<DBSignalQueueItem[]> => {
      const { data, error } = await supabase.rpc("next_signals_for_me", { p_limit: QUEUE_SIZE });
      if (error) throw error;
      return (data ?? []) as unknown as DBSignalQueueItem[];
    },
    enabled: enabled && !!user,
    staleTime: 30 * 1000,
  });
}
